import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { parseBreadcrumbsList } from '../../store/Actions';
import Header from '../layout/Header';
import Sidebar from '../layout/Sidebar';
import Footer from '../layout/Footer';
import Breadcrumbs from '../Reusables/Breadcrumbs';
import { useLocation,useNavigate, useParams } from 'react-router-dom';
import trash from '../../images/common/trash.png';
import download from '../../images/common/download.png';
import FormSubmission from '../popups/FormSubmission';
import getContact from '../actions/Contacts';
import upsort from '../../images/common/upsort.png'
import downsort from '../../images/common/downsort.png'
import DeleteItem from '../popups/DeleteItem';
import Spinner from '../Reusables/Spinner';
import overview from '../../images/common/edit-blue.png';
import CreateNewcontact from '../pages/NewContact';
import RefreshToken from '../actions/RefreshToken';
import { convertUTCToPST, getCSVData } from '../Reusables/Function';
import getCommonResponse from '../actions/Common';

function ContactInfo() {
    const location = useLocation();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const {id} = useParams();
    const [showform, setShowform] = useState(false);
    const [infolist, setInfolist] = useState([]);
    const [entity, setEntity] = useState('');
    const [Email, setEmail] = useState([]);
    const [phonenum, setPhonenumber] = useState([]);
    const [formlistdata, setFormlistdata] = useState('');
    const [formdata, setFormContactdata] = useState([]);
    const [totalcount, setTotalcount] = useState([]);
    const params = new URLSearchParams(location.search);
    const sort = params.has('sort') ? params.get('sort') : ''
    const sort_order = params.has('sort_order') ? params.get('sort_order') : ''
    const [issort, setSort] = useState(false);
    const [isbool, setbool] = useState(false);
    const [isLoading, setLoading] = useState(true);
    const [show, setShow] = useState(false);
    const [deleteBrandId, setDeleteBrandId] = useState(null);
    const [deleteProjectId, setDeleteProjectId] = useState(null);
    const [deleteproject, setDeleteproject] = useState('');
    const [overEdit, setOverEdit] = useState(false);
    const [propertyDetails, setPropertyDetails] = useState([]);
    const [toggle, setToggle] = useState(false);
    const [formEditted, setFormEditted] = useState(null);
    const [downloadLink, setDownloadLink] = useState([]);


    const handleFormShow = () => {
        setToggle(!toggle)
        setShowform(true);
    }
    const handleFormHide = () => setShowform(false);

    const editValues = {
        page: "edit-project"
    }
    const breadcrumbsList = [
        { "name": "Home", "url": "" },
        { "name": "Contacts", "url": "contacts/list"},
        { "name": "Contact Info", "url": `contacts/${id}/view` }
    ];
    const tableHeaders = [
        { "name": "Number", "sort": false, "width": "220px" },
        { "name": "Flag", "sort": false, "width": "200px" },
    ];
    const tableHeader = [
        { "name": "Email", "sort": false, "width": "250px" },
        { "name": "Flag", "sort": false, "width": "200px" },
    ];
    const tableHeadersProperty = [
        { "name": "Property", "sort": false, "width": "200px" },
        { "name": "Relationship", "sort": false, "width": "200px" },
        { "name": "", "sort": false, "width": "100px" }
    ];
    function showForm() {
        let bool = true;
        const event = document.getElementsByClassName('form-show');
        if(event[0].innerHTML == 'Show All') {
            event[0].innerHTML = 'Show Less';
            bool = false;
            setbool(bool)
            ShowContact(bool);
        }
        else if(event[0].innerHTML == 'Show Less'){
            event[0].innerHTML = 'Show All';
            bool = true;
            setbool(bool)
            ShowContact(bool);
        }
    }
    function handleformdata(item,event) {
        event.stopPropagation();
        handleFormShow();
        setFormlistdata(item);
    }
   
    function SortProject(dataset) {
        const element = document.getElementsByClassName('form-show');
        if(element[0].innerHTML == 'Show Less' && totalcount != formdata.length) {
            element[0].innerHTML = 'Show All';
        } else {
            element[0].innerHTML = 'Show Less';
        }
        
        function CallAPI(accesstoken) {
            if(accesstoken === '') {
                navigate('/login');
            }
            else { 
                let sortBy = dataset.sortBy;
                let sortType = dataset.sortType;
                navigate(`/contacts/${id}/view?page=1$&sort=${sortBy}&sort_order=${sortType}`);
                getContact.ContactForm(`/api/contacts/formsubmission/list?contactId=${id}&showAll=true&sortKey=${sortBy}&sortOrder=${sortType}`, accesstoken, (data) => {
                    if (data.status == 200) {
                        setFormContactdata(data.data.data);
                        setTotalcount(data.data.totalCount);
                        getCsvData(data.data.data);
                    } else if(data.status == 401) {
                        navigate("/login")
                    }
                });
                setSort(!issort)
            }
        }
        RefreshToken((accesstoken) => CallAPI(accesstoken));
    }

    const getCsvData = (data) => {
        setDownloadLink(getCSVData(data));
    }

    function deleteContact() {
        function CallAPI(accesstoken) {
            if(accesstoken === '') {
                navigate('/login');
            }
            else {
                getCommonResponse.DeleteApi(`/api/project/form/delete/${deleteProjectId}`, accesstoken, (data)=> {
                    if(data.status == 200) {
                        handleClose();
                        setDeleteproject(deleteProjectId);
                    } else if(data.status == 401) {
                        navigate("/login")
                    }
                })
            }
        }
        RefreshToken((accesstoken) => CallAPI(accesstoken));

    }
    function deleteForm (id,event) {
        event.stopPropagation();
        setDeleteProjectId(id);
        handleShow();
    }
    function ShowContact(bool) {
        function CallAPI(accesstoken) {
            if(accesstoken === '') {
                navigate('/login');
            }
            else {
                if(bool === true) {
                    getContact.ContactForm(`/api/contacts/formsubmission/list?contactId=${id}`, accesstoken, (data) => {
                        if (data.status == 200) {
                            setFormContactdata(data.data.data);
                            setTotalcount(data.data.totalCount)
                            getCsvData(data.data.data);
                        } else if(data.status == 401) {
                            navigate("/login")
                        }
                    });
                }
                else {
                    getContact.ContactForm(`/api/contacts/formsubmission/list?contactId=${id}&showAll=true`, accesstoken, (data) => {
                        if (data.status == 200) {
                            setFormEditted(false);
                            setFormContactdata(data.data.data);
                            setTotalcount(data.data.totalCount)
                            getCsvData(data.data.data);
                        } else if(data.status == 401) {
                            navigate("/login")
                        }
                    });
                }
            }
        }
        RefreshToken((accesstoken) => CallAPI(accesstoken));
    }
    const handleClose = () => {
        setShow(false);
        if(deleteProjectId != null) {
            const element = document.getElementsByClassName('form-show');
            if(element[0].innerHTML == 'Show Less' && totalcount != formdata.length) {
                element[0].innerHTML = 'Show All';
            } else {
                element[0].innerHTML = 'Show Less';
            }
            ShowContact(false);
        }
    }

    useEffect(() => {
        if(formEditted) {
            const element = document.getElementsByClassName('form-show');
            if(element[0].innerHTML == 'Show Less' && totalcount != formdata.length) {
                element[0].innerHTML = 'Show All';
            } else {
                element[0].innerHTML = 'Show Less';
            }
            ShowContact(false);
        }
    }, [formEditted])

    const handleShow = () => {
        setShow(true);
    }
    function Overviewedit() {
        setOverEdit(!overEdit)
        // navigate(`/contacts/list/${id}/edit`)
    }
    const setShowView = (value) => {
        setOverEdit(false)
    }
    useEffect(()=> {
        const path = window.location.href;
        const pathSplit = path.split('/');
        const id = parseInt(pathSplit[pathSplit.length - 2]);
        function CallAPI(accesstoken) {
            if(accesstoken === '') {
                navigate('/login');
            }
            else if(accesstoken === 'noToken') {
                navigate('/login', {state : {path : window.location.pathname+window.location.search+window.location.hash}});
            }
            else {
                getContact.ContactForm(`/api/contacts/formsubmission/list?contactId=${id}`, accesstoken, (data) => {
                    if (data.status == 200) {
                        setFormContactdata(data.data.data);
                        setTotalcount(data.data.totalCount);
                        getCsvData(data.data.data);
                    } else if(data.status == 401) {
                        navigate("/login")
                    }
                });
                getContact.ContactInfo(`/api/contacts/info?contactId=${id}`, accesstoken, (data) => {
                    if (data.status == 200) {
                        setInfolist(data.data.data);
                        let info = data.data.data;
                        // setEntity(info.entity.entityName);
                        setEmail(info.emails);
                        setPhonenumber(info.phoneNumbers);
                        setLoading(false);
                        setPropertyDetails(info.entities)
                    } else if(data.status == 401) {
                        navigate("/login")
                    }
                });
            }
        }
        RefreshToken((accesstoken) => CallAPI(accesstoken));
    },[overEdit])
    useEffect(() => {
        dispatch(parseBreadcrumbsList(breadcrumbsList));
    }, [issort,overEdit])

    useEffect(() => {
        let bool = true;
        if(formdata.length == totalcount) {
            bool = true;
            ShowContact(bool);
        }
        else{
            bool = false;
            ShowContact(bool);
        }
    }, [isbool])

    const handleFormDownload = (e, item, index) => {
        e.stopPropagation();
        const element = document.createElement("a");
        element.href = downloadLink[index];
        element.download = `${item.title}.txt`;
        document.body.appendChild(element);
        element.click();
    }

    const propertyRedirection = (propertyId) => {
        window.open(`/properties/${propertyId}/view`, "_blank")
    }

    return(
        <>
        {!overEdit ? 
        (<div className="contact-info-page-container">
            <Header />
            <div className='row new-contact-info-sub-container'>
                <Sidebar />
                <div className='col-10 create-new-body-container'>
                    <div className='sub-header'>
                        <Breadcrumbs/>
                        {isLoading ?
                            (<Spinner/>) :
                        (<div>
                            <div className='edit-project-content'>
                                <div className="edit-overview-info">
                                <h3>Info</h3>
                                <img onClick={Overviewedit} className="edit-overview-image" src={overview}/>
                                </div>
                                <div className='row label-input-row label-spacing-input'>
                                    <div className='col-4 label-input-col'>
                                        <div className='label-input label-input-name'>
                                            <label>Name</label>
                                            <div className='input-box'> 
                                                <input type="text" value={`${infolist.firstName} ${infolist.lastName != null ? infolist.lastName : ''}`} readOnly/>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='col-4 label-input-col'>
                                        <div className='label-input label-input-name'>
                                            <label>Email Id</label>
                                            <div className='input-box'> 
                                                <input type="text" value={infolist.email}  readOnly/>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='col-4 label-input-col'>
                                        <div className='label-input label-input-name'>
                                            <label>Title</label>
                                            <div className='input-box'> 
                                                <input type="text" value={infolist.title}  readOnly></input>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='col-4 label-input-col'>
                                        <div className='label-input label-input-name'>
                                            <label>Portal</label>
                                            <div className='input-box'> 
                                                <input type="text" value={infolist.brand.name}  readOnly></input>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='col-4 label-input-col'>
                                        <div className='label-input label-input-name'>
                                            <label>Franchise Category</label>
                                            <div className='input-box'> 
                                                <input type="text" value={infolist.franchise}  readOnly></input>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='property-body'>
                                        <div className='table-view-container'>
                                            <div className='list-items'>
                                                <table>
                                                    <thead>
                                                        <tr className='heading-row'>
                                                            {tableHeadersProperty != null && tableHeadersProperty.map((item, index) => {
                                                                return (
                                                                    <>
                                                                        <th className={`${'heading-data'+index}`} style={{ minWidth: `${item.width}` }}>
                                                                            <div className='flex-display'>
                                                                                <div className='label'>{item.name}</div>  
                                                                            </div>                                  
                                                                        </th>
                                                                    </>
                                                                )
                                                            })}
                                                        </tr>
                                                    </thead>
                                                    {
                                                        propertyDetails && propertyDetails.length === 0 ? <p className="no-result">No results found</p> :
                                                        <tbody>
                                                            {propertyDetails != null && propertyDetails.map((item, index) => {
                                                                return (
                                                                    <tr key={index} onClick={() => propertyRedirection(item.idEntities)}>
                                                                        <td className='task-data1'>{item.name}</td>
                                                                        <td className='task-data2'>{item.relationship}</td>
                                                                        <td className='task-data3'></td>
                                                                    </tr>
                                                                )
                                                            })}
                                                        </tbody>
                                                    }
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <hr />
                                <div className="phone-mail-contact">
                                    <div className="phone-contact">
                                        <h3>Phone Number</h3>
                                        <div className='table-view-container-list'>
                                            <div className='list-items'>
                                                <table>
                                                    <thead>
                                                        <tr className='heading-row'>
                                                            {tableHeaders.map(item => {
                                                                return (
                                                                    <th className='heading-data' style={{ minWidth: `${item.width}` }}>
                                                                        <div className='label'>{item.name}</div>                                               
                                                                    </th>
                                                                )
                                                            })}
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {phonenum != null && phonenum.map((item, index) => {
                                                            return (
                                                                <tr id={index}>
                                                                    <td className='data2'>{item.phoneNumber && item.countryCode+" "+item.phoneNumber}</td>
                                                                    <td className='data5'>{index == 0 ? "Primary" : "Secondary"}</td>
                                                                </tr>
                                                            )
                                                        })}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="mail-contact">
                                        <h3>Email ID</h3>
                                        <div className='table-view-container-list'>
                                            <div className='list-items'>
                                                <table>
                                                    <thead>
                                                        <tr className='heading-row'>
                                                            {tableHeader.map(item => {
                                                                return (
                                                                    <th className='heading-data' style={{ minWidth: `${item.width}` }}>
                                                                        <div className='label'>{item.name}</div>                                           
                                                                    </th>
                                                                )
                                                            })}
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {Email != null && Email.map((item, index) => {
                                                            return (
                                                                <tr id={index}>
                                                                    <td className='data2'>{item}</td>
                                                                    <td className='data5'>{index == 0 ? "Primary" : "Secondary"}</td>
                                                                </tr>
                                                            )
                                                        })}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <hr />
                                <div className='row label-input-row label-spacing-input'>
                                    <div className='col-12 label-input-col label-input-address'>
                                        <div className='label-input label-input-name'>
                                            <label>Address</label>
                                            <div className='input-box'> 
                                                <input type="text" value={infolist.address} readOnly/>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className='row label-input-row label-spacing-input'>
                                    <div className='col-4 label-input-col'>
                                        <div className='label-input label-input-name'>
                                            <label>City</label>
                                            <div className='input-box'> 
                                                <input type="text" value={infolist.city}  readOnly/>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='col-4 label-input-col'>
                                        <div className='label-input label-input-name'>
                                            <label>State / Province</label>
                                            <div className='input-box'> 
                                                <input type="text" value={infolist.state}  readOnly></input>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='col-4 label-input-col'>
                                        <div className='label-input label-input-name'>
                                            <label>Zip / Postal Code</label>
                                            <div className='input-box'> 
                                                <input type="text" value={infolist.zipCode}  readOnly></input>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <hr/>
                                <div id='forms' className="form-submission">
                                    <div className="form-header">
                                        <h3>Form Submission</h3> 
                                        <p>Showing {formdata.length} forms of {totalcount}</p>
                                        <p className="form-show" onClick={() => showForm()}>{totalcount > 5 ? "Show All" : ""}</p>
                                    </div>
                                    <div className="form-table">
                                        <div className='table-view-container-list'>
                                            <div className='list-items'>
                                                <table>
                                                    <thead>
                                                        <tr className='heading-row'>
                                                            <th className='heading-data' style={{ minWidth : "250px" }}>
                                                                <div className="form-content-header">
                                                                    <div className='label'>Title</div>
                                                                    <div className='sort-arrows'>
                                                                        {
                                                                            !(sort === 'Title' && sort_order === 'Ascending') && 
                                                                            <img className='uparrow' src={upsort} alt="uparrow" data-sort-by='Title' data-sort-type='Ascending' onClick={(e) => SortProject(e.target.dataset)}></img>
                                                                        }
                                                                        {
                                                                            !(sort === 'Title' && sort_order === 'Descending') && 
                                                                            <img className='downarrow' src={downsort} alt="downarrow" data-sort-by='Title' data-sort-type='Descending' onClick={(e) => SortProject(e.target.dataset)}></img>
                                                                        }
                                                                    </div> 
                                                                </div>                                                  
                                                            </th>
                                                            <th className='heading-data' style={{ minWidth: "197px" }}>
                                                                <div className="form-content-header">
                                                                    <div className='label'>Date & Time</div>
                                                                    <div className='sort-arrows'>
                                                                        {
                                                                            !(sort === 'Date' && sort_order === 'Ascending') && 
                                                                            <img className='uparrow' src={upsort} alt="uparrow" data-sort-by='Date' data-sort-type='Ascending' onClick={(e) => SortProject(e.target.dataset)}></img>
                                                                        }
                                                                        {
                                                                            !(sort === 'Date' && sort_order === 'Descending') && 
                                                                            <img className='downarrow' src={downsort} alt="downarrow" data-sort-by='Date' data-sort-type='Descending' onClick={(e) => SortProject(e.target.dataset)}></img>
                                                                        }
                                                                    </div>   
                                                                </div>                                                
                                                            </th>
                                                            <th className='heading-data' style={{ minWidth: "100px" }}>
                                                                <div className='label'>Actions</div>                                               
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    {
                                                        formdata.length == 0 ? <p className="no-result">No results found</p> : 
                                                    <tbody>
                                                        {formdata.length > 0 && formdata.map((item, index) => {
                                                            return (
                                                                <tr id={`${'formlist' + index}`} onClick={(event) => handleformdata(item,event)}>
                                                                    <td id={`${'formlist' + index}`} className='data1'>{item.title}</td>
                                                                    <td id={`${'formlist' + index}`} className='data2'>{convertUTCToPST(item.createdDate + 'Z', "updates")}</td>
                                                                    <td className='data6'>
                                                                        {/* {csvdata[index] && csvdata[index].length > 0 &&
                                                                            <CSVLink data={csvdata[index]} 
                                                                            filename={item.title}
                                                                            onClick={event => {
                                                                            event.stopPropagation();
                                                                            }}>                                                                            
                                                                                <img id={`${index}`} className='edit' src={download} alt="edit"></img>
                                                                            </CSVLink> 
                                                                        }   */}
                                                                        <div><img className='download' src={download} alt="download" onClick={(e) => handleFormDownload(e, item, index)}/></div>
                                                                        <div><img id={`${index}`} className='trash' onClick={(event) => deleteForm(item.idFormSubmission,event)} src={trash} alt="delete"></img></div>
                                                                    </td>
                                                                </tr>
                                                            )
                                                        })}
                                                        { formlistdata &&
                                                            <FormSubmission showform={showform} handleFormHide={handleFormHide} formlistdata={formlistdata} toggle={toggle} setFormEditted={setFormEditted}/>
                                                        }
                                                    </tbody>
                                                    }
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>)}
                    </div>
                </div>
            </div>
            <Footer />
            <DeleteItem show={show} handleClose={handleClose} deleteApiCall={deleteContact} enable={true}/>
        </div>):<>
        <CreateNewcontact setShowView={setShowView}/>
        </>
    }
    </>
    )
}
export default ContactInfo;